import React, { useRef, useState } from "react";
import { TooltipContainer } from "@outplayed/tooltips";
import DefaultSelect from "components/DefaultSelect";
import { useTranslation } from "react-i18next";

const Encounter = (props) => {
  const tooltipRef = useRef();
  const { t } = useTranslation();
  const { className, isMobile, disabled, options, isDefault, onFilterChange, disableTooltip, selectedVal } = props;

  if (disabled) {
    return null;
  }

  const formatOptionLabel = ({ value, label, img }) => (
    <div className="encounter-option">
      <span>{t(label)}</span>
    </div>
  );

  return (
    <TooltipContainer
      ref={tooltipRef}
      tooltipInfo={t("Change encounter")}
      customClassName={className}
      disableTooltip={isMobile || disableTooltip}
    >
      <div>
        <DefaultSelect
          title={t("Change Encounter")}
          group={"class"}
          isMobile={isMobile}
          className={`filter-select filter-select_class ${isDefault}`}
          options={options}
          onChange={(selected) => {
            onFilterChange("encounter", selected.value);
          }}
          value={selectedVal}
          formatOptionLabel={formatOptionLabel}
          width={150}
          isSearchable={false}
          onMenuClose={() => tooltipRef.current.forceClose()}
        />
      </div>
    </TooltipContainer>
  );
};

export default Encounter;
